import React from 'react';
import {
    Show,
    TextField,
    TopToolbar,
    FunctionField,
    DateField,
    SelectField
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import ContractRequestDetailsButton from "../component/ContractRequestDetailsButton";
import {Card, CardContent} from "@material-ui/core";
import ContractContentWidgetDialog from "../component/ContractContentWidgetDialog";
import programs from "../helper/MedicalProgramsList";

const useStyles = makeStyles((theme) => ({
    separator: {
        width: '10px',
        clear: 'none'
    }
}));

const cardStyle = {
    width: "100%",
    margin: '0.5em',
    padding: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 500,
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
};
const rowStyle = {
    margin: '0',
    lineHeight: '30px',
    padding: "3px 0",
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
};
const labelStyle = {
    display: 'inline-block',
    width: 200,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};

const ContractRequestShow = props => {
    const classes = useStyles();

    const ContractRequestShowTitle = ({ record }) => {
        return <span>Заявка на договір: {record ?`${record.id}` : ''}</span>;
    };

    const ContractRequestActions = ({ basePath, data, resource }) => {
        return (
            <TopToolbar>
                {typeof data !== 'undefined' && ('NHS_SIGNED' === data.status) ?
                    <ContractRequestDetailsButton {...props} idForm={data.idForm} /> : null}

                {typeof data !== 'undefined' && (
                    'APPROVED' === data.status
                    || 'PENDING_NHS_SIGN' === data.status
                    || 'NHS_SIGNED' === data.status
                    || 'SIGNED' === data.status
                ) ?
                    <ContractContentWidgetDialog {...props} contractNumber={data.id}/>
                : null}
            </TopToolbar>
        );
    };


    const Label = (prop) => {
        return (
            <span style={labelStyle}>{prop.caption}: </span>
        );
    }

    const contractsValues = {
        NEW: "НОВА",
        IN_PROCESS: "ОБРОБЛЯЄТЬСЯ",
        APPROVED: "ПІДТВЕРДЖЕНА",
        DECLINED: "ВІДМІНЕНА",
        PENDING_NHS_SIGN: "ОЧІКУЄ НА ПІДПИСАННЯ ВІД НСЗУ",
        NHS_SIGNED: "ПІДПИСАНА НСЗУ",
        TERMINATED: "ЗАВЕРШЕНА"
    }

    return (
        <Show className="show-styles" {...props} title={<ContractRequestShowTitle/>} actions={<ContractRequestActions/>}>
            <div style={{ margin: '1em' }}>
                <div className="legal-entity-list-show">
                    <Card style={cardStyle}>
                        <CardContent style={rowStyle}>
                            <Label caption={"ID"}/>
                            <TextField label="ID" source="id"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Номер договору"}/>
                            <TextField source="contractNumber"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Підстава договору"}/>
                            <TextField source="contractorBase"  />
                            {/*<SelectField source="contractorBase"  choices={[*/}
                            {/*    { id: 'на підставі статуту', name: 'на підставі статуту' },*/}
                            {/*    { id: 'на підставі домовленісті', name: 'на підставі домовленісті' },*/}
                            {/*]} />*/}
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Мед. програма"}/>
                            <FunctionField source="medicalProgramId"
                                           render={record => {
                                               let result = [];

                                               if (record.medicalProgramId) {
                                                   for (let i = 0; i < record.medicalProgramId.length; i++) {
                                                       result.push(programs[record.medicalProgramId[i]]);
                                                   }
                                               }

                                               return result.length > 0 ? result.join(', ') : '';
                                           }} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Статус запиту"}/>
                            <FunctionField source="status"
                                render={record => contractsValues[record.status]} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Місце заявки на договір"}/>
                            <TextField source="issueСity"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Дата початку дії"}/>
                            <DateField source="startDate" />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Дата закінчення дії"}/>
                            <DateField source="endDate" />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Текст угоди"}/>
                            <TextField source="consentText"
                                       initialValue={"Цією заявою Заявник висловлює бажання укласти договір про реімбурсацію з Національною службою здоров'я України та підтверджує, що на момент подання цієї заяви Заявник провадить господарську діяльність на підставі ліцензії на провадження господарської діяльності з роздрібної торгівлі лікарськими засобами та відповідає ліцензійним умовам. Заявник усвідомлює, що у разі зміни інформації, зазначеної Заявником у цій заяві та (або) доданих до неї документах Заявник зобов'язаний повідомити про такі зміни НСЗУ протягом трьох робочих днів з дня настання таких змін шляхом надсилання інформації про такі зміни на електронну пошту reimb@nszu.gov.ua, з одночасним внесенням таких змін в Систему. Заявник усвідомлює, що законодавством України передбачена відповідальність за подання недостовірної інформації органам державної влади."}
                            />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Номер банківського рахунку (IBAN)"}/>
                            <TextField source="payerAccount"  />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Назва банку"}/>
                            <TextField source="bankName" />
                        </CardContent>
                     </Card>
                </div>
            </div>
        </Show>
    );
};

export default ContractRequestShow;
